export const model = {
  id: null,    
  created_at: '',
  updated_at: '',
  
};
